import { createSelector } from 'reselect'
// import { List } from 'immutable'

const publicHolidaySelector = state => state.get('publicHoliday')

export const getIsFetching = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return publicHoliday.publicHolidayList.isFetching
    || publicHoliday.publicHolidayGet.isFetching
    || publicHoliday.publicHolidayEdit.isFetching
    || publicHoliday.publicHolidayCreate.isFetching
    || publicHoliday.publicHolidayDelete.isFetching
    || publicHoliday.publicHolidayExport.isFetching
  }
)
export const getPublicHolidayData = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return publicHoliday.publicHolidayList.holidays || []
  }
)
export const getPublicHolidayByIDData = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return publicHoliday.publicHolidayGet.holiday
  }
)
export const editPublicHolidayData = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return publicHoliday.publicHolidayEdit
  }
)
export const createPublicHolidayData = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return publicHoliday.publicHolidayCreate
  }
)
export const deletePublicHolidayData = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return publicHoliday.publicHolidayDelete
  }
)
export const getExportURL = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return publicHoliday.publicHolidayExport.url
  }
)
export const redirectPublicHoliday = createSelector(
  publicHolidaySelector,
  publicHolidayImmutable => {
    const publicHoliday = publicHolidayImmutable.toJS()
    return ({
      redirect: (publicHoliday.publicHolidayList.redirect
      || publicHoliday.publicHolidayGet.redirect
      || publicHoliday.publicHolidayEdit.redirect
      || publicHoliday.publicHolidayCreate.redirect
      || publicHoliday.publicHolidayDelete.redirect
      || publicHoliday.publicHolidayExport.redirect),
      isAuthenticated: (publicHoliday.publicHolidayList.isAuthenticated
      || publicHoliday.publicHolidayGet.isAuthenticated
      || publicHoliday.publicHolidayEdit.isAuthenticated
      || publicHoliday.publicHolidayCreate.isAuthenticated
      || publicHoliday.publicHolidayDelete.isAuthenticated
      || publicHoliday.publicHolidayExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/public-holiday/public-holiday-selector.js